/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-template */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/button-has-type */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-danger */
/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  MdInfo,
  MdKeyboardArrowRight,
  MdKeyboardArrowLeft,
  MdFlight,
  MdClose,
  MdOutlineShare,
  MdOutlineEmail,
  MdOutlineWhatsapp,
} from 'react-icons/md';
import { IoBag } from 'react-icons/io5';
import PropTypes from 'prop-types';
import {
  formatTimeString,
  formatTimeStringAmPmFormat,
  convertTravelTime,
  formatDate,
  getConnectingTime,
  formatCurrency,
  getTerminalNumberwithT,
  failedResponseForFareRules,
  getCabinBaggage,
  getSupplierName,
  showSupplier,
  getOnlyTerminalNumber,
  getNewDate,
  getNumSeats,
  isMobileWidth,
  isEmpty,
  getFlightNumbers,
  getEquipment,
  getOperatedBy,
  getNewDateDisplayFormat,
  getLegBaggage,
  getBaggage,
  getFareTaxBreakup,
} from '../../shared/helper-utils/appUtils';
import AppButton from '../../shared/components/app-button/AppButton';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppLink from '../../shared/components/app-link/AppLink';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import {
  getBrandedFaresApi,
  getClassAvailability,
  getClassAvailabilityFare,
  getFareRulesApi,
  getMiniFareRulesApi,
} from '../../api/flightApi';
import './OneWayResultCard.scss';
import SelectedFlightDetails from './SelectedFlightDetails';
import {
  DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
  DATE_MONTH_VIEW_FORMAT,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  INDIGO_FARERULES_LINK,
  MOMENT_DATE_MONTH_YEAR_VIEW_FORMAT,
} from '../../shared/constants/Constants';
import AppSidebar from '../../shared/components/app-sidebar/AppSidebar';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import AppHidden from '../../shared/components/app-hidden/AppHidden';
import CheckforMobile from '../../shared/components/app-hidden/CheckforMobile';
import StopOverInfo from './StopOverInfo';
import AppFlightLogo from '../../shared/components/app-flight-logo/AppFlightLogo';
import { useAppContext } from '../../saas/AppConfigWrapper';
import OneWayFareComponent from './OneWayFareComponent';
import FareCard from '../../shared/components/fare-card/FareCard';
import FareBreakup from '../../shared/components/fare-card/FareBreakup';
import FareRulesContent from '../../shared/components/fare-rules-content/FareRulesContent';
import ClassAvailabilitySidebar from '../../shared/components/class-availability-sidebar/ClassAvailabilitySidebar';

const FLIGHT_INFO = 'flight';
const FARE_BREAKUP = 'fare-breakup';
const FARE_RULES = 'fare-rules';
const MINIFARES = 'mini-fares';

const tripTypeDict = {
  OneWay: 'oneway_btn',
  RoundTrip: 'roundtrip_btn',
};

function OneWayResultCard({
  domint,
  flight,
  selectedFare,
  onFareSelection,
  journeyType,
  isOnward,
  onSelectForEmail,
  showInvoiceFare,
  flightsForEmail,
  searchRequest,
  index,
  isAmPmFormat,
  onNavigateToBookingPage,
  onClassSelectForRoundtrip,
  onShareViaEmail,
  onShareViaWhatsapp,
  fareInclusions,
  onMoreFaresUpdate = () => {},
}) {
  const { appConfig } = useAppContext();
  const isMobileView = CheckforMobile();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [isOpenFareRulesDialog, setIsOpenFareRulesDialog] = useState(false);
  const [isOpenMiniFareRulesDialog, setIsOpenMiniFareRulesDialog] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fareRulesHtml, setFareRulesHtml] = useState('');
  const [miniFareRulesHtml, setMiniFareRulesHtml] = useState('');
  const [isAmedeusFareRules, setIsAmedeusFareRules] = useState(false);
  const [showFares, setShowFares] = useState(false);
  const [showFlightDetails, setShowFlightDetails] = useState(false);
  const [selectedTab, setSelectedTab] = useState(FLIGHT_INFO);
  const [userSelectedFare, setUserSelectedFare] = useState(
    flight.flightfare[0],
  );
  const [alert, setAlert] = useState(undefined);
  const [isBranded, setIsBranded] = useState(false);
  const [brandedFareKey, setBrandedFareKey] = useState(undefined);
  const [brandedFlightList, setBrandedFlightList] = useState([]);
  const [isMoreFaresLoading, setIsMoreFaresLoading] = useState(false);
  const [isMoreFaresCallDone, setIsMoreFaresCallDone] = useState(false);
  const [showBrandedList, setShowBrandedList] = useState(false);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [showClassAvailModal, setShowClassAvailModal] = useState(false);
  const [availClassList, setAvailClassList] = useState([]);
  const [isFareFetched, setIsFareFetched] = useState(false);
  const [repriceResponse, setRepriceResponse] = useState(undefined);
  const [showMobileFares, setShowMobileFares] = useState(false);
  const [showShareOptions, setShowShareOptions] = useState(false);
  // const [showScrollButton, setShowScrollButton] = useState(false);
  const fareListScrollPositionRef = useRef(0);

  const [hasAmenities, setHasAmenities] = useState(false);
  const [amenitiesList, setAmenitiesList] = useState([]);
  const [isopenAmenitiesdialog, setisopenAmenitiesdialog] = useState(false);
  const scrollRight = () => {
    const scrollableDiv = document.getElementById(
      `scrollableDiv-${flight.nextraflightkey}`,
    );
    scrollableDiv.scrollLeft += 300;
  };
  const isIndiaClient = getValueFromAppConfig('isIndiaClient') === 'true';

  const scrollLeft = () => {
    const scrollableDiv = document.getElementById(
      `scrollableDiv-${flight.nextraflightkey}`,
    );
    scrollableDiv.scrollLeft -= 300;
  };

  const checkForBranded = () => {
    const fares = flight.flightfare;
    let brandedFare;
    fares.forEach((fare) => {
      const branded = fare.ismorefaresavailable === 'true';
      if (branded) {
        brandedFare = fare;
      }
    });
    if (brandedFare) {
      setBrandedFareKey(brandedFare.nextraflightkey);
      setIsBranded(true);
      // console.log(flight); ABACUSBRANDED UAPINEWBRANDED
    }
  };

  useEffect(() => {
    checkForBranded();
  }, []);

  // Preserve horizontal scroll position of the fare list across re-renders.
  // When FareComponent (inline/nested) instances unmount and remount on every
  // render, the scrollable div loses its content width temporarily and the
  // browser resets scrollLeft to 0. This effect restores the saved position
  // synchronously before the browser paints, so there is no visible jump.
  useLayoutEffect(() => {
    if (showFares) {
      const scrollableDiv = document.getElementById(
        `scrollableDiv-${flight.nextraflightkey}`,
      );
      if (scrollableDiv) {
        scrollableDiv.scrollLeft = fareListScrollPositionRef.current;
      }
    }
  });

  const handleShowBrandedFares = async () => {
    // setShowMoreFares(!showMoreFares);
    if (brandedFlightList.length === 0 && flight?.moreFaresCallDOne !== true) {
      setIsMoreFaresLoading(true);
      const res = await getBrandedFaresApi(
        searchRequest,
        brandedFareKey,
        getUserAgentId(),
        journeyType,
        domint,
      );
      if (
        res &&
        res.flightjourneys[0] !== '' &&
        res.flightjourneys[0] !== undefined
      ) {
        const flightOptions = Array.isArray(res.flightjourneys[0].flightoptions)
          ? res.flightjourneys[0].flightoptions
          : [res.flightjourneys[0].flightoptions];
        const isTotalNet = getValueFromAppConfig('sortingtotalnet') === 'true';
        flightOptions.sort((flightOption1, flightOption2) =>
          isTotalNet
            ? flightOption1.recommendedflight[0].flightfare.totalnet -
              flightOption2.recommendedflight[0].flightfare.totalnet
            : flightOption1.recommendedflight[0].flightfare.totalfq -
              flightOption2.recommendedflight[0].flightfare.totalfq,
        );
        const list = [];
        flightOptions.forEach((fo) => {
          const carrierList = [];
          const seatsList = [];
          const bagList = [];
          const weighlist = [];
          const bookingClassList = [];
          const airFreeTextList = [];
          const equipmentList = [];
          const operatedByList = [];
          const handBagWeightList = [];
          const handBagWeightUnitList = [];
          fo.recommendedflight[0].flightlegs.forEach((leg) => {
            carrierList.push(leg.carrier);
            seatsList.push(leg.numseatsavailable);
            bagList.push(leg.bagweight);
            weighlist.push(leg.bagunit);
            bookingClassList.push(leg.bookingclass);
            if (leg.weather_origin !== '') {
              airFreeTextList.push(leg.weather_origin);
            }
            handBagWeightList.push(leg.cabinBagweight);
            handBagWeightUnitList.push(leg.cabinBagunit);
            equipmentList.push(isEmpty(leg.equipment) ? '' : leg.equipment);
            operatedByList.push(isEmpty(leg.operatedby) ? '' : leg.operatedby);
          });
          const fare = fo.recommendedflight[0].flightfare;
          fare.supplierName = fo.recommendedflight[0].supplier;
          fare.nextraflightkey = fo.recommendedflight[0].nextraflightkey;
          fare.nextracustomstr = fo.recommendedflight[0].nextracustomstr;
          fare.isminifarerulesrequired =
            fo.recommendedflight[0].isminifarerulesrequired;
          fare.airFreeText = airFreeTextList;
          fare.flightCarrier = carrierList;
          fare.numseatsavailable = seatsList;
          fare.flightBagWeight = bagList;
          fare.flightBagUnit = weighlist;
          fare.flightEquipment = equipmentList;
          fare.flightOperatedBy = operatedByList;
          fare.cabinBagweight = handBagWeightList;
          fare.cabinBagunit = handBagWeightUnitList;
          fare.bookingClass = bookingClassList;
          fare.isBrandedFare = true;
          list.push(fare);
        });
        const oldFares = [...flight.flightfare];
        const updatesFares = [...oldFares, ...list];
        updatesFares.sort((fare1, fare2) =>
          isTotalNet
            ? fare1.totalnet - fare2.totalnet
            : fare1.totalfq - fare2.totalfq,
        );
        flight.flightfare = updatesFares;
        setBrandedFlightList(flightOptions);
        onMoreFaresUpdate(list, flight.nextraflightkey);
      }
      setIsMoreFaresLoading(false);
    }
    setIsMoreFaresCallDone(true);
    setShowBrandedList(!showBrandedList);
  };

  const handleShowMoreFares = () => {
    if (
      isBranded &&
      brandedFlightList.length === 0 &&
      !isMoreFaresCallDone &&
      !appConfig.isMoreFaresRequiredForEachFareType
    ) {
      handleShowBrandedFares();
    }
    setShowFares((prev) => !prev);
  };

  const getAvailClasses = async () => {
    if (
      journeyType.toLowerCase() === 'roundtrip' &&
      availClassList.length > 0
    ) {
      setShowClassAvailModal(true);
      return false;
    }
    setIsLoading(true);
    const res = await getClassAvailability(
      userSelectedFare.nextraflightkey,
      domint,
    );
    if (res) {
      let { flights } = res;
      flights = Array.isArray(flights) ? flights : [flights];
      if (flights.length > 0) {
        flights.forEach((availflight) => {
          let { availclasses } = availflight;
          availclasses = Array.isArray(availclasses)
            ? availclasses
            : [availclasses];
          availflight.availclasses = availclasses;
        });
        const list = flights.map((flt) => ({
          carrier: flt.carrier,
          flightnumber: flt.flightnumber,
          selectedclass: '',
        }));
        setSelectedClasses(list);
        setAvailClassList(flights);
        setShowClassAvailModal(true);
      } else {
        setAlert({
          title: 'Class Availability',
          description: 'Cannot Fetch Details',
          variant: 'error',
        });
      }
    }
    setIsLoading(false);
  };
  const handleClassSelect = (
    availClass,
    index,
    tripNum,
    cabinClass,
    gwFlightKey,
  ) => {
    setRepriceResponse(undefined);
    setIsFareFetched(false);
    const list = [...selectedClasses];
    // list[index][name] = availClass.class;
    list[index] = {
      selectedclass: availClass.class,
      availabilityKey: availClass.availabilityKey,
      tripNum,
      cabinClass,
      gwFlightKey,
    };
    setSelectedClasses(list);
  };

  const handleFetchFare = async () => {
    let selectedClassesCount = 0;
    selectedClasses.forEach((selectedclass) => {
      const isSelectedClass = selectedclass.selectedclass !== '';
      if (isSelectedClass) {
        selectedClassesCount += 1;
      }
    });
    if (selectedClassesCount < selectedClasses.length) {
      setAlert({
        title: 'Fetch Fare',
        description: 'Select on class for every sector',
        variant: 'error',
      });
      return;
    }
    setIsLoading(true);
    const response = await getClassAvailabilityFare(
      userSelectedFare.nextraflightkey,
      domint,
      selectedClasses,
      journeyType.toLowerCase(),
    );
    if (
      response &&
      response.NextraPricingResponseV4 &&
      response.NextraPricingResponseV4.statuscode === '200'
    ) {
      setRepriceResponse(response.NextraPricingResponseV4);
      setIsFareFetched(true);
    } else if (
      response &&
      response.ApiStatus &&
      response.ApiStatus.Status === 'NOK'
    ) {
      setAlert({
        title: 'Booking Error',
        description: response.ApiStatus?.Message,
        variant: 'error',
      });
    } else {
      setAlert({
        title: 'Booking Error',
        description: 'Error',
        variant: 'error',
      });
    }
    setIsLoading(false);
  };
  const handleCloseClassAvailabilityModal = () => {
    setShowClassAvailModal(false);
    if (journeyType.toLowerCase() === 'oneway') {
      setSelectedClasses([]);
      setAvailClassList([]);
      setRepriceResponse(undefined);
      setIsFareFetched(false);
    }
  };

  const handleClassSelectForRoundtrip = () => {
    const selectedClassFare =
      repriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0]
        .flightfare;
    onClassSelectForRoundtrip(
      flight,
      userSelectedFare,
      selectedClassFare,
      selectedClasses,
      isOnward,
    );
    setShowClassAvailModal(false);
  };

  // const handleClearClassSelection = () => {
  //   if (clearClassSelection && journeyType.toLowerCase() === 'roundtrip') {
  //     setSelectedClasses([]);
  //     setAvailClassList([]);
  //     setRepriceResponse(undefined);
  //     setIsFareFetched(false);
  //   }
  // };

  // useEffect(() => {
  //   handleClearClassSelection();
  // }, [clearClassSelection]);

  const handleNavigateToBookingPage = () => {
    onNavigateToBookingPage(userSelectedFare.nextraflightkey, repriceResponse);
  };

  const handleSelectForEmail = (fare) => {
    onSelectForEmail(flight, fare);
  };

  const handleShowFlightDetails = () => {
    setShowFlightDetails(true);
    setSelectedTab(FLIGHT_INFO);
  };

  const handleFareRulesClick = async (fare) => {
    // if (
    //   ['6E', '6ET', '6E7'].indexOf(fare.flightCarrier[0]) > -1 &&
    //   domint === 'international'
    // ) {
    //   const link = INDIGO_FARERULES_LINK;
    //   const element = document.createElement('a');
    //   element.href = link;
    //   element.target = '_blank';
    //   element.click();
    //   return;
    // }
    setIsLoading(true);
    const response = await getFareRulesApi(fare.nextraflightkey, '', domint);
    if (
      response &&
      response.wsstatus &&
      response.wsstatus.status === 'OK' &&
      response.wsstatus.statusCode === '200'
    ) {
      if (
        JSON.parse(response.farerules_html) &&
        JSON.parse(response.farerules_html)?.html !== '' &&
        JSON.parse(response.farerules_html)?.html !== 'null'
      ) {
        setFareRulesHtml(JSON.parse(response.farerules_html)?.html);
      } else {
        setFareRulesHtml(failedResponseForFareRules);
      }
    } else if (
      response &&
      response.ApiStatus &&
      response.ApiStatus.Status === 'OK'
    ) {
      if (response.ApiStatus.Result.hasOwnProperty('AllFareRules')) {
        setFareRulesHtml(response.ApiStatus.Result?.AllFareRules.Rule);
      } else if (response.ApiStatus.Result) {
        setFareRulesHtml(response.ApiStatus.Result.Rule);
      } else {
        setFareRulesHtml(failedResponseForFareRules);
      }
    } else {
      setFareRulesHtml(failedResponseForFareRules);
    }
    setIsLoading(false);
    setIsOpenFareRulesDialog(true);
  };

  const handleShowMiniFareRules = async (fare) => {
    console.log(fare);
    setIsLoading(true);
    const response = await getMiniFareRulesApi(
      fare.nextraflightkey,
      '',
      domint,
    );
    setIsAmedeusFareRules(false);
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      if (fare.supplierName === 'amadeus') {
        setIsAmedeusFareRules(true);
        let { Rule } = response?.ApiStatus?.Result?.MiniFarerule;
        if (!isEmpty(Rule)) {
          Rule = Array.isArray(Rule) ? Rule : [Rule];
          setMiniFareRulesHtml(Rule);
          setIsOpenMiniFareRulesDialog(true);
        } else {
          setMiniFareRulesHtml([]);
        }
      } else {
        const { Result } = response.ApiStatus;
        if (Result && Result !== '') {
          let { list } = Result;
          list = Array.isArray(list) ? list : [list];
          // const resheduleRules = list.filter(
          //   (rule) => rule?.typequalifier?.toLowerCase() === 'change',
          // );
          // const CancelRule = list.filter(
          //   (rule) => rule?.typequalifier?.toLowerCase() === 'cancellation',
          // );
          const resheduleRules = list.filter((rule) =>
            rule?.typequalifier?.toLowerCase().includes('change'),
          );

          const CancelRule = list.filter((rule) =>
            rule?.typequalifier?.toLowerCase().includes('cancel'),
          );

          const rules = {
            reshedule: resheduleRules || [],
            cancellation: CancelRule || [],
          };
          if (resheduleRules.length > 0 || CancelRule.length > 0) {
            setMiniFareRulesHtml(rules);
            setIsOpenMiniFareRulesDialog(true);
          } else {
            setAlert({
              variant: 'error',
              title: 'Mini Fare Rules',
              description: 'Mini fare rules not available at the moment',
            });
          }
        } else {
          setAlert({
            variant: 'error',
            title: 'Mini Fare Rules',
            description: 'Mini fare rules not available at the moment',
          });
        }
      }
    } else {
      setAlert({
        variant: 'error',
        title: 'Mini Fare Rules',
        description: 'Mini fare rules not available at the moment',
      });
    }
    setIsLoading(false);
  };

  const handleOpenFareRules = async () => {
    // if (
    //   ['6E', '6ET', '6E7'].indexOf(userSelectedFare.flightCarrier[0]) > -1 &&
    //   domint === 'international'
    // ) {
    //   const link = INDIGO_FARERULES_LINK;
    //   const element = document.createElement('a');
    //   element.href = link;
    //   element.target = '_blank';
    //   element.click();
    //   return;
    // }
    setIsLoading(true);
    const response = await getFareRulesApi(
      userSelectedFare.nextraflightkey,
      '',
      domint,
    );
    if (
      response &&
      response.wsstatus &&
      response.wsstatus.status === 'OK' &&
      response.wsstatus.statusCode === '200'
    ) {
      if (
        JSON.parse(response.farerules_html) &&
        JSON.parse(response.farerules_html)?.html !== '' &&
        JSON.parse(response.farerules_html)?.html !== 'null'
      ) {
        setFareRulesHtml(JSON.parse(response.farerules_html)?.html);
      } else {
        setFareRulesHtml(failedResponseForFareRules);
      }
    } else if (
      response &&
      response.ApiStatus &&
      response.ApiStatus.Status === 'OK'
    ) {
      if (response.ApiStatus.Result.hasOwnProperty('AllFareRules')) {
        setFareRulesHtml(response.ApiStatus.Result?.AllFareRules.Rule);
      } else if (response.ApiStatus.Result) {
        setFareRulesHtml(response.ApiStatus.Result.Rule);
      } else {
        setFareRulesHtml(failedResponseForFareRules);
      }
    } else {
      setFareRulesHtml(failedResponseForFareRules);
    }
    setIsLoading(false);
    setSelectedTab(FARE_RULES);
  };

  const getAmenitiesFromFare = (fare) => {
    if (
      !fare ||
      !fare.amenities ||
      isEmpty(fare.amenities) ||
      fare.amenities !== '-'
    ) {
      return [];
    }
    return Array.isArray(fare.amenities) ? fare.amenities : [fare.amenities];
  };

  const hasAmenitiesForFare = (fare) => getAmenitiesFromFare(fare).length > 0;

  const handleCheckForAmenities = () => {
    try {
      const amenities = getAmenitiesFromFare(userSelectedFare);
      if (amenities.length > 0) {
        setAmenitiesList(amenities);
        setHasAmenities(true);
      } else {
        setAmenitiesList([]);
        setHasAmenities(false);
      }
    } catch (error) {
      setAmenitiesList([]);
      setHasAmenities(false);
    }
  };

  useEffect(() => {
    handleCheckForAmenities(userSelectedFare);
  }, [userSelectedFare]);

  const handleShowAmenites = (fare) => {
    const amenities = getAmenitiesFromFare(fare);
    if (amenities.length === 0) {
      return;
    }
    setUserSelectedFare(fare);
    setAmenitiesList(amenities);
    setHasAmenities(true);
    setisopenAmenitiesdialog(true);
  };

  const isFareSelectedForEmail = (fare) => {
    if (flightsForEmail.length > 0) {
      const present = flightsForEmail.some(
        (d) => d.fare.nextraflightkey === fare.nextraflightkey,
      );
      if (present) {
        return true;
      }
      return false;
    }
    return false;
  };

  const getYQForTheFare = (fare) => {
    let yq = 0;
    if (fare.othertaxesbreakup && fare.othertaxesbreakup.length > 0) {
      const { othertaxesbreakup } = fare;
      othertaxesbreakup.forEach((tax) => {
        if (tax.taxcode.toLowerCase() === 'adt_yq') {
          yq += tax.taxamount;
        }
      });
    }
    return yq;
  };

  const getK3ForTheFare = (fare) => {
    let yq = 0;
    if (fare.othertaxesbreakup && fare.othertaxesbreakup.length > 0) {
      const { othertaxesbreakup } = fare;
      othertaxesbreakup.forEach((tax) => {
        const isK3 = tax.taxcode.toLowerCase().includes('k3');
        if (isK3) {
          yq += tax.taxamount;
        }
      });
    }
    return yq;
  };

  const handleCloseMobileFare = () => {
    setShowMobileFares(false);
    window.history.back();
  };

  const handleBook = (fare) => {
    setUserSelectedFare(fare);
    onFareSelection(flight, fare);
    if (isMobileView) {
      handleCloseMobileFare();
    }
    // if (searchRequest.journeytype === 'RoundTrip') {

    // }
  };

  const getMealForFlight = (fareType) => {
    if (flight.islcc === 'false') {
      return 'free';
    }
    if (
      // fareType.toLowerCase().indexOf('corporate') > -1 ||
      fareType.toLowerCase().indexOf('flexi') > -1
    ) {
      return 'meals included';
    }
    return 'chargeable';
  };

  const getWaterMarkForFare = () => {
    let watermark = '';
    for (let i = 0; i < 100; i++) {
      watermark += `${getUserAgentId()} `;
    }
    return watermark;
  };

  const getFlightCabinBaggage = (weight, unit, index = 0) => {
    if (selectedFare) {
      if (isOnward) {
        return getCabinBaggage(
          selectedFare.cabinBagweight[index],
          selectedFare.cabinBagunit[index],
        );
      }
      return getCabinBaggage(
        selectedFare.returnCabinBagweight[index],
        selectedFare.returnCabinBagunit[index],
      );
    }
    return getCabinBaggage(weight, unit);
  };

  function FareComponent({ fare }) {
    // New fare card with inclusions & penalties (toggle: FareCardWithInclusion
    // in saas/AppConfigWrapper.jsx).
    if (appConfig?.FareCardWithInclusion) {
      const legacyInclusion = fareInclusions?.[fare.faretype];
      const legacyBaggage = flight?.nextracustomstr?.includes(
        'iweenflightgateway',
      )
        ? null
        : legacyInclusion;
      return (
        <FareCard
          fare={fare}
          watermark={getWaterMarkForFare()}
          isSelected={fare.nextraflightkey === userSelectedFare.nextraflightkey}
          onSelect={setUserSelectedFare}
          topActions={
            <>
              {appConfig.companyName === 'Vayaonline' &&
              fare.supplierName === 'STTECH' ? (
                <span className="fs-12">{fare.flightCarrier?.[0]}</span>
              ) : null}
              {fare?.ismorefaresavailable === 'true' &&
                !isMoreFaresCallDone &&
                (isMoreFaresLoading ? (
                  <div className="dots-container d-flex align-items-center">
                    <div className="dot" />
                    <div className="dot" />
                    <div className="dot" />
                  </div>
                ) : (
                  <AppLink
                    linkText="More Fares"
                    className="more-fares-link"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShowBrandedFares();
                    }}
                  />
                ))}
            </>
          }
          priceClassName={
            appConfig.ShowTboPriceBlack === 'true' &&
            fare?.supplierName?.toLowerCase() === 'tbo'
              ? ''
              : 'primary-color'
          }
          showInvoiceFare={showInvoiceFare}
          fareBreakup={
            <FareBreakup fare={fare} showInvoiceFare={showInvoiceFare} />
          }
          isSeriesFare={searchRequest.searchtype === 'seriesfares'}
          legacyInclusion={legacyInclusion}
          checkinFallback={
            legacyBaggage?.Checkin ||
            getCabinBaggage(
              fare?.flightBagWeight?.[0],
              fare?.flightBagUnit?.[0],
            )
          }
          cabinFallback={
            legacyBaggage?.HandBaggage ||
            getCabinBaggage(fare?.cabinBagweight?.[0], fare?.cabinBagunit?.[0])
          }
          infoRows={[
            {
              label: 'Class',
              value: fare.bookingClass?.join(','),
              className: 'class',
            },
            ...(showSupplier()
              ? [
                  {
                    label: 'Supplier',
                    value: getSupplierName(fare.supplierName),
                    className: 'suppiler',
                  },
                ]
              : []),
          ]}
          seatGroups={[{ seats: fare.numseatsavailable }]}
          links={
            <>
              <AppLink
                linkText="Fare Rules"
                variant="secondary"
                className="fs-14"
                onClick={() => handleFareRulesClick(fare)}
              />
              {fare.isminifarerulesrequired === 'true' && (
                <AppLink
                  linkText="Mini Fare rules"
                  variant="secondary"
                  className="fs-12"
                  onClick={() => handleShowMiniFareRules(fare)}
                />
              )}
              {hasAmenitiesForFare(fare) && (
                <AppLink
                  linkText="Amenities"
                  variant="secondary"
                  className="fs-12"
                  onClick={() => handleShowAmenites(fare)}
                />
              )}
            </>
          }
          onBook={handleBook}
          footer={
            <>
              <AppCheckBox
                name="emailorwhatsapp"
                id={fare.nextraflightkey}
                labelText="Share via Email or WhatsApp"
                onChange={() => handleSelectForEmail(fare)}
                checked={isFareSelectedForEmail(fare)}
              />
              {fare.airFreeText?.length > 0 && (
                <div className="fs-12 green-color">
                  {fare.airFreeText.join(',')}
                </div>
              )}
            </>
          }
        />
      );
    }
    return (
      <div
        className={`fare-component-mobile ${
          fare.isBrandedFare ? 'branded-border' : ''
        } fare-component-watermark`}
        // onClick={() => handleFareSelection(fare)}
        data-watermark={getWaterMarkForFare()}
      >
        <div className="d-flex justify-content-between flex-column h-100 fareCard">
          <div className="watermark-actions d-flex justify-content-between align-items-center">
            <AppRadioInput
              id={fare.nextraflightkey}
              name={fare.nextraflightkey}
              radioClassName="radioButton"
              checked={
                fare.nextraflightkey === userSelectedFare.nextraflightkey
              }
              onChange={() => setUserSelectedFare(fare)}
              labelText={
                fare.nextraflightkey === userSelectedFare.nextraflightkey
                  ? 'Selected'
                  : 'Select'
              }
            />
            {appConfig.companyName === 'Vayaonline' &&
              fare.supplierName === 'STTECH' && (
                <span className="fs-12">{fare.flightCarrier?.[0]}</span>
              )}
            {fare?.ismorefaresavailable === 'true' &&
              !isMoreFaresCallDone &&
              (isMoreFaresLoading ? (
                <div className="dots-container d-flex align-items-center">
                  <div className="dot" />
                  <div className="dot" />
                  <div className="dot" />
                </div>
              ) : (
                <AppLink
                  linkText="More Fares"
                  className="more-fares-link"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShowBrandedFares();
                  }}
                />
              ))}
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Fare Type</span>
              <span className="fs-16 fw-600 text-capitalize fare-type-span d-flex text-end">
                <span className="fareType">{fare.faretype}</span>
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Cancellation</span>
              <span className="fare-component_value">
                {' '}
                {fareInclusions[fare.faretype]
                  ? fareInclusions[fare.faretype]?.Cancellation
                  : 'Chargeable'}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Reschedule</span>
              <span className="fare-component_value">
                {' '}
                {fareInclusions[fare.faretype]
                  ? fareInclusions[fare.faretype]?.Reissue
                  : 'Chargeable'}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Meal</span>
              <span className="fare-component_value">
                {getMealForFlight(fare.faretype)}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Seat</span>
              <span className="fare-component_value">chargeable</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Check In</span>
              <span className="fare-component_value checkIn">
                {/* {getCabinBaggage(
                  fare.flightBagWeight[0],
                  fare.flightBagUnit[0],
                )} */}
                {flight?.nextracustomstr?.includes('iweenflightgateway')
                  ? getCabinBaggage(
                      fare?.flightBagWeight?.[0],
                      fare?.flightBagUnit?.[0],
                    )
                  : fareInclusions?.[fare?.faretype]?.Checkin
                  ? fareInclusions[fare.faretype].Checkin
                  : getCabinBaggage(
                      fare?.flightBagWeight?.[0],
                      fare?.flightBagUnit?.[0],
                    )}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Cabin</span>
              <span className="fare-component_value cabin">
                {flight?.nextracustomstr?.includes('iweenflightgateway')
                  ? getCabinBaggage(
                      fare?.cabinBagweight?.[0],
                      fare?.cabinBagunit?.[0],
                    )
                  : fareInclusions[fare.faretype]?.HandBaggage
                  ? fareInclusions[fare.faretype]?.HandBaggage
                  : getFlightCabinBaggage(
                      fare.cabinBagweight,
                      fare.cabinBagunit,
                      index,
                    )}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Class</span>
              <span className="fare-component_value class">
                {fare.bookingClass.join(',')}
              </span>
            </div>
            {showSupplier() && (
              <div className="d-flex justify-content-between align-items-center">
                <span className="fare-component_title">Supplier</span>
                <span className="fare-component_value suppiler">
                  {getSupplierName(fare.supplierName)}
                </span>
              </div>
            )}
            <div className="d-flex justify-content-between align-items-center mt-1">
              {searchRequest.searchtype === 'seriesfares' ? (
                <span className="fare_non-refundable reFundableInfo">
                  Non Refundable/ <br /> Non changeable
                </span>
              ) : (
                <span className="fare-component_value">
                  {fare.refundableinfo === 'Y' ? (
                    <span className="fare_refundable reFundableInfo">
                      Refundable
                    </span>
                  ) : (
                    <span className="fare_non-refundable reFundableInfo">
                      Non Refundable
                    </span>
                  )}
                </span>
              )}
              <span className="fs-12 red-color fw-600">
                {fare.numseatsavailable &&
                fare.numseatsavailable.length > 0 &&
                parseInt(fare.numseatsavailable[0], 10) > 0 ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip
                        id={`available-seats-tooltip-${fare.nextraflightkey}`}
                      >
                        Seats left: {fare.numseatsavailable.join(', ')}
                      </Tooltip>
                    }
                  >
                    <span style={{ cursor: 'pointer' }}>
                      {getNumSeats(fare.numseatsavailable[0])} seats left
                    </span>
                  </OverlayTrigger>
                ) : (
                  ''
                )}
              </span>
            </div>
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-center my-2 watermark-actions">
              <div className="d-flex flex-column">
                {hasAmenitiesForFare(fare) && (
                  <AppLink
                    linkText="Amenities"
                    variant="secondary"
                    className="fs-12"
                    onClick={() => handleShowAmenites(fare)}
                  />
                )}

                <div className="d-flex gap-2 align-items-center">
                  <div className="d-flex flex-column">
                    <div
                      className={`fs-16 fw-600 totalFare ${
                        appConfig.ShowTboPriceBlack === 'true' &&
                        fare?.supplierName?.toLowerCase() === 'tbo'
                          ? ''
                          : 'primary-color'
                      }`}
                    >
                      {formatCurrency(fare.totalfq)}
                    </div>
                    {showInvoiceFare && (
                      <div className="fs-12 secondary-color">
                        {formatCurrency(fare.totalnet)}
                      </div>
                    )}
                  </div>
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="fare-breakup-tooltip">
                        <div className="fare-breakup">
                          <div className="fare-breakup_content">
                            <div className="fare-breakup_title">Base Fare</div>
                            <div className="fare-breakup_value">
                              {formatCurrency(fare.totalbasefare)}
                            </div>
                          </div>
                          {/* <div className="fare-breakup_content">
                      <div className="fare-breakup_title">YQ Tax</div>
                      <div className="fare-breakup_value">
                        {formatCurrency(getYQForTheFare(fare))}
                      </div>
                    </div> */}
                          <div className="fare-breakup_content">
                            <div className="fare-breakup_title">Tax</div>
                            <div className="fare-breakup_value">
                              {formatCurrency(fare.totaltax)}
                            </div>
                          </div>
                          {/* <div className="fare-breakup_content">
                      <div className="fare-breakup_title">K3</div>
                      <div className="fare-breakup_value">
                        {formatCurrency(getK3ForTheFare(fare))}
                      </div>
                    </div> */}
                          <div className="fare-breakup_content">
                            <div className="fare-breakup_title">HC</div>
                            <div className="fare-breakup_value">
                              {formatCurrency(fare.handlingcharges)}
                            </div>
                          </div>
                          <div className="fare-breakup_content">
                            <div className="fare-breakup_title">
                              {' '}
                              {appConfig?.isIntlClient === 'true'
                                ? 'VAT'
                                : 'GST'}
                            </div>
                            <div className="fare-breakup_value">
                              {formatCurrency(fare.servicetax)}
                            </div>
                          </div>
                          <div className="fare-breakup_content">
                            <div className="fare-breakup_title">
                              Other Charges
                            </div>
                            <div className="fare-breakup_value">
                              {formatCurrency(fare.transactionfee)}
                            </div>
                          </div>

                          {showInvoiceFare && (
                            <>
                              <div className="fare-breakup_content">
                                <div className="fare-breakup_title">
                                  Discount
                                </div>
                                <div className="fare-breakup_value">
                                  {formatCurrency(fare.discount)}
                                </div>
                              </div>
                              <div className="fare-breakup_content">
                                <div className="fare-breakup_title">TDS</div>
                                <div className="fare-breakup_value">
                                  {formatCurrency(fare.tds)}
                                </div>
                              </div>
                              <div className="fare-breakup_content">
                                <div className="fare-breakup_title">
                                  Net Fare
                                </div>
                                <div className="fare-breakup_value">
                                  {formatCurrency(fare.totalnet)}
                                </div>
                              </div>
                            </>
                          )}
                          <div className="fare-breakup_content">
                            <div className="fare-breakup_title">Total Fare</div>
                            <div className="fare-breakup_value">
                              {formatCurrency(fare.totalfq)}
                            </div>
                          </div>
                        </div>
                      </Tooltip>
                    }
                  >
                    <div className="cursor-pointer secondary-color">
                      <MdInfo />
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="d-flex flex-column">
                {/* {!fare.isBrandedFare && ( */}
                <AppLink
                  linkText="Fare Rules"
                  variant="secondary"
                  className="fs-14"
                  onClick={() => handleFareRulesClick(fare)}
                />
                {/* )} */}
                {fare.isminifarerulesrequired === 'true' && (
                  <AppLink
                    linkText="Mini Fare rules"
                    variant="secondary"
                    className="fs-10"
                    onClick={() => handleShowMiniFareRules(fare)}
                  />
                )}
              </div>
            </div>
            <div className="d-flex my-1 watermark-actions">
              <AppButton
                btnText="Book now"
                variant="primary"
                className="fs-16 flex-1 bookNow"
                onClick={() => handleBook(fare)}
              />
            </div>
            <div className="watermark-actions">
              <AppCheckBox
                name="emailorwhatsapp"
                id={fare.nextraflightkey}
                labelText="Share via Email or WhatsApp"
                onChange={() => handleSelectForEmail(fare)}
                checked={isFareSelectedForEmail(fare)}
              />
            </div>
            {fare.airFreeText.length > 0 && (
              <div className="mt-1 fs-12 green-color">
                {fare.airFreeText.join(',')}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  FareComponent.propTypes = {
    fare: PropTypes.object.isRequired,
  };

  const handleMobileContinue = () => {
    if (isMobileWidth()) {
      if (
        isBranded &&
        brandedFlightList.length === 0 &&
        !isMoreFaresCallDone &&
        !appConfig.isMoreFaresRequiredForEachFareType
      ) {
        handleShowBrandedFares();
      }
      window.history.pushState({ popupOpen: true }, '');
      setShowMobileFares(true);
    }
  };

  const isCardClickEnabled =
    getValueFromAppConfig('ENABLE_FLIGHT_CARD_CLICK') === 'true';

  const handleCardClick = () => {
    if (!isCardClickEnabled || isMobileWidth() || isMoreFaresLoading) return;
    handleShowMoreFares();
  };
  useEffect(() => {
    const handlePopState = (event) => {
      if (showMobileFares) {
        setShowMobileFares(false); // Close the popup instead of navigating
      }
    };

    // Add event listener for popstate
    window.addEventListener('popstate', handlePopState);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showMobileFares]);
  return (
    <>
      <div
        className={` d-flex flex-column mb-2 one-way-new-result-card oneWayCard ${
          showFares ? 'mb-0 pb-0' : ''
        }`}
      >
        <AppLoading isLoading={isLoading} />
        {alert && (
          <AppAlert
            showIcon
            variant={alert.variant}
            title={alert.title}
            onHide={() => setAlert(undefined)}
            description={alert.description}
          />
        )}
        <div
          className={`d-flex w-100 flex-sm-row flex-column ${
            isCardClickEnabled ? 'cursor-pointer' : ''
          }`}
          onClick={handleCardClick}
        >
          <div className="d-flex flight-info" onClick={handleMobileContinue}>
            <Row className="spacing-0 flex-1 flight-info_flight-details">
              <Col
                lg={4}
                md={4}
                sm={4}
                xs={3}
                className="d-flex flex-sm-row flex-column"
              >
                <div className="flight-info_flight-details">
                  <div className="d-flex">
                    <div className="d-flex me-2 flight-image">
                      <AppFlightLogo
                        carrier={flight.flightlegs[0].carrier.substring(0, 2)}
                        className="vertical-bottom"
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column flight-name">
                  <span className="flight-company flightCompanyName">
                    {flight.flightlegs[0].validatingcarriername}
                  </span>
                  <span className="fs-10 flight-number flightNumber">
                    {getFlightNumbers(flight, userSelectedFare)}
                  </span>
                  {getEquipment(flight, userSelectedFare) !== '' && (
                    <span className="fs-8 fw-300 grey-color flight-equipment equipmentDetails">
                      {getEquipment(flight, userSelectedFare)
                        ?.trim()
                        ?.toUpperCase() === 'BUS' ||
                      getEquipment(flight, userSelectedFare)
                        ?.trim()
                        ?.toUpperCase() === 'BUS TRANSFER'
                        ? 'Bus Transfer'
                        : `Equipment: ${getEquipment(
                            flight,
                            userSelectedFare,
                          )}`}
                    </span>
                  )}
                  {getOperatedBy(flight, userSelectedFare) !== '' && (
                    <span className="fs-8 fw-300 grey-color flight-operated-by OperatedBy">
                      Operated By: {getOperatedBy(flight, userSelectedFare)}
                    </span>
                  )}
                </div>
              </Col>
              <Col lg={8} md={8} sm={8} xs={9}>
                {!isMobileWidth() ? (
                  <Row>
                    <Col
                      lg={5}
                      md={5}
                      sm={5}
                      xs={5}
                      className="d-flex justify-content-start"
                    >
                      <div className="d-flex flex-column">
                        <span className="title fw-600 depTime">
                          {isAmPmFormat
                            ? formatTimeStringAmPmFormat(
                                flight.flightlegs[0].deptime,
                              )
                            : formatTimeString(flight.flightlegs[0].deptime)}
                        </span>
                        <span
                          style={{ fontSize: '12px', color: '#768391' }}
                          className="terminalNumber"
                        >
                          {flight.flightlegs[0].origin}
                          {getTerminalNumberwithT(
                            flight.flightlegs[0].depterminal,
                          )}
                        </span>
                        {/* <span className="fs-10">
                        {flight.flightlegs[0].origin_name}
                      </span> */}
                      </div>
                    </Col>
                    <Col
                      lg={2}
                      md={2}
                      sm={2}
                      xs={2}
                      className="d-flex justify-content-center px-0"
                    >
                      <div className="d-flex flex-column text-center">
                        <span className="fs-12 fw-500 grey-color flightDuration">
                          {convertTravelTime(flight.totaljourneyduration)}
                        </span>
                        <StopOverInfo flight={flight} />
                      </div>
                    </Col>
                    <Col
                      lg={5}
                      md={5}
                      sm={5}
                      xs={5}
                      className="d-flex justify-content-end"
                    >
                      <div className="d-flex flex-column align-items-end text-end w-100">
                        <span className="title fw-600 arrTime">
                          {isAmPmFormat
                            ? formatTimeStringAmPmFormat(
                                flight.flightlegs[flight.flightlegs.length - 1]
                                  .arrtime,
                              )
                            : formatTimeString(
                                flight.flightlegs[flight.flightlegs.length - 1]
                                  .arrtime,
                              )}
                          {flight.flightlegs[0].depdate !==
                            flight.flightlegs[flight.flightlegs.length - 1]
                              .arrdate && (
                            <span className="extra-days">+1</span>
                          )}
                        </span>
                        <span
                          style={{ fontSize: '12px', color: '#768391' }}
                          className="arrivalTerminalNumber"
                        >
                          {
                            flight.flightlegs[flight.flightlegs.length - 1]
                              .destination
                          }
                          {getTerminalNumberwithT(
                            flight.flightlegs[flight.flightlegs.length - 1]
                              .arrterminal,
                          )}
                        </span>
                        {/* <span className="fs-10">
                        {
                          flight.flightlegs[flight.flightlegs.length - 1]
                            .destination_name
                        }
                      </span> */}{' '}
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    {/* <Col
                      lg={4}
                      md={4}
                      sm={4}
                      xs={4}
                      className="d-flex justify-content-start"
                    >
                      <div className="d-flex flex-column">
                        <span className="title fw-600">
                          {isAmPmFormat
                            ? formatTimeStringAmPmFormat(
                                flight.flightlegs[0].deptime,
                              )
                            : formatTimeString(flight.flightlegs[0].deptime)}
                        </span>
                        <span className="fs-12 fw-300 grey-color">
                          {convertTravelTime(flight.totaljourneyduration)}
                        </span>
                      </div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4} className="d-flex">
                      <div className="d-flex flex-column">
                        <span className="title fw-600">
                          {isAmPmFormat
                            ? formatTimeStringAmPmFormat(
                                flight.flightlegs[0].arrtime,
                              )
                            : formatTimeString(flight.flightlegs[0].arrtime)}
                        </span>
                        <span className="fs-12 fw-300 grey-color">
                          <StopOverInfo flight={flight} />
                        </span>
                      </div>
                    </Col> */}
                    <Col lg={8} md={8} sm={8} xs={8}>
                      <div className="d-flex justify-content-between">
                        <div className="d-flex flex-column">
                          <span
                            className={`${
                              isAmPmFormat ? 'fs-12' : 'sub-title'
                            } fw-600`}
                          >
                            {isAmPmFormat
                              ? formatTimeStringAmPmFormat(
                                  flight.flightlegs[0].deptime,
                                )
                              : formatTimeString(flight.flightlegs[0].deptime)}
                          </span>
                          <span
                            style={{ fontSize: '12px', color: '#768391' }}
                            className="terminalNumber"
                          >
                            {flight.flightlegs[0].origin}
                            {getTerminalNumberwithT(
                              flight.flightlegs[0].depterminal,
                            )}
                          </span>
                        </div>

                        <span className="fs-12 fw-300 grey-color mt-2">
                          <StopOverInfo flight={flight} />
                          <span className="fs-10 fw-300 grey-color">
                            {convertTravelTime(flight.totaljourneyduration)}
                          </span>
                        </span>

                        <div className="d-flex flex-column">
                          <span
                            className={`${
                              isAmPmFormat ? 'fs-12' : 'sub-title'
                            } fw-600`}
                          >
                            {isAmPmFormat
                              ? formatTimeStringAmPmFormat(
                                  flight.flightlegs[
                                    flight.flightlegs.length - 1
                                  ].arrtime,
                                )
                              : formatTimeString(
                                  flight.flightlegs[
                                    flight.flightlegs.length - 1
                                  ].arrtime,
                                )}
                          </span>
                          <span
                            style={{ fontSize: '12px', color: '#768391' }}
                            className="arrivalTerminalNumber"
                          >
                            {
                              flight.flightlegs[flight.flightlegs.length - 1]
                                .destination
                            }
                            {getTerminalNumberwithT(
                              flight.flightlegs[flight.flightlegs.length - 1]
                                .arrterminal,
                            )}
                          </span>
                        </div>
                      </div>
                    </Col>
                    <Col
                      lg={4}
                      md={4}
                      sm={4}
                      xs={4}
                      className="d-flex justify-content-end"
                    >
                      <div className="d-flex flex-column text-end">
                        <div className="fs-16 fw-600 primary-color totalPrice">
                          {formatCurrency(
                            userSelectedFare?.totalfq ||
                              flight.flightfare[0].totalfq,
                          )}
                        </div>
                        {showInvoiceFare && (
                          <span className="fs-12 fw-400 primary-color">
                            {formatCurrency(
                              userSelectedFare?.totalnet ||
                                flight.flightfare[0].totalnet,
                            )}
                          </span>
                        )}
                        {parseInt(
                          flight.flightfare[0].numseatsavailable[0],
                          10,
                        ) !== 0 && (
                          <span className="fs-10 fw-600 red-color">
                            {`${getNumSeats(
                              flight.flightfare[0].numseatsavailable[0],
                            )} seats left`}
                          </span>
                        )}
                        {isMoreFaresLoading ? (
                          <div className="d-flex justify-content-end mt-1">
                            <div className="dots-container d-flex align-items-center">
                              <div className="dot" />
                              <div className="dot" />
                              <div className="dot" />
                            </div>
                          </div>
                        ) : (
                          <AppLink
                            linkText={
                              showMobileFares ? 'Hide Fares' : 'More Fares'
                            }
                            variant="secondary"
                            className="fs-10 fw-600 mt-1 viewPrice"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (showMobileFares) {
                                handleCloseMobileFare();
                              } else {
                                handleMobileContinue();
                              }
                            }}
                          />
                        )}
                        <AppLink
                          linkText={formattedMessage('flight_details')}
                          className="fs-10 fw-600 mt-1 flightDetails"
                          variant="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleShowFlightDetails();
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </div>
          <div className=" d-flex fare-info justify-content-between hide-in-mobile">
            <div
              className="d-flex flex-column me-3 flex-1 text-end one-way-watermarked"
              data-watermark={`${getUserAgentId()}${getUserAgentId()} ${getUserAgentId()}${getUserAgentId()} ${getUserAgentId()}${getUserAgentId()}`}
            >
              <span className="fs-18 fw-600 secondary-color totalFare">
                {/* {formatCurrency(flight.flightfare[0].totalfq)} */}
                {formatCurrency(userSelectedFare.totalfq)}
              </span>
              {showInvoiceFare && (
                <span className="fs-12 fw-400 primary-color">
                  {/* {formatCurrency(flight.flightfare[0].totalnet)} */}
                  {formatCurrency(userSelectedFare.totalnet)}
                </span>
              )}
              <span className="fs-10 fw-600 red-color ">
                {/* {getNumSeats(flight.flightfare[0].numseatsavailable[0])} seats
                left */}
                {parseInt(flight.flightfare[0].numseatsavailable[0], 10) === 0
                  ? ''
                  : `${getNumSeats(
                      flight.flightfare[0].numseatsavailable[0],
                    )} seats left`}
              </span>
            </div>
            <div className="d-flex flex-column align-items-center">
              {isMoreFaresLoading ? (
                <div className="d-flex justify-content-center mt-2">
                  <div className="dots-container d-flex align-items-center">
                    <div className="dot" />
                    <div className="dot" />
                    <div className="dot" />
                  </div>
                </div>
              ) : (
                <AppLink
                  linkText={showFares ? 'Hide Fares' : 'More Fares'}
                  variant="secondary"
                  className="fs-14 fw-600 viewPrice "
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShowMoreFares();
                  }}
                />
              )}
              <AppLink
                linkText={formattedMessage('flight_details')}
                className="fs-12 fw-600 mt-1 flightDetails"
                variant="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  handleShowFlightDetails();
                }}
              />
            </div>
          </div>
        </div>
        {appConfig?.appMainUrl === 'https://uatb2badmin.etrvl.com/' && (
          <div>
            {/* {flight.islcc === 'false' && domint === 'domestic' && ( */}
            <AppLink
              linkText="Class Availability"
              className="fs-12 fw-500 hide-in-mobile"
              variant="green"
              onClick={getAvailClasses}
            />
            {/* )} */}
          </div>
        )}
        {isOpenFareRulesDialog && (
          <AppSidebar
            sidebarTitle={formattedMessage('fare_rules_btn')}
            animatedClass="slide-from-right-animation"
            onHideSidebar={() => setIsOpenFareRulesDialog(false)}
            className="overflow-auto flight-details-sidebar"
          >
            <FareRulesContent
              html={fareRulesHtml}
              className="fare-rules-content"
              style={{ overflow: 'auto' }}
            />
          </AppSidebar>
        )}
        {isOpenMiniFareRulesDialog && (
          <AppSidebar
            sidebarTitle="Mini Fare Rules"
            animatedClass="slide-from-right-animation"
            onHideSidebar={() => setIsOpenMiniFareRulesDialog(false)}
            className="overflow-auto flight-details-sidebar"
          >
            <table className="table-bordered w-100 fs-14 mini-fare-rules-table">
              <thead>
                <tr>
                  <th>{isAmedeusFareRules ? 'TypeQualifier' : 'Type'}</th>
                  <th>Description</th>
                  <th>Charges</th>
                </tr>
              </thead>
              {isAmedeusFareRules ? (
                <tbody>
                  {miniFareRulesHtml.map((x, index) => (
                    <tr key={index}>
                      <td>{x.TypeQualifier}</td>
                      <td>{x.Description}</td>
                      <td>{`${x.Currency} ${x.Amount}`}</td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td>Reschedule Charges</td>
                    {/* <td>Adult</td> */}
                    <td>{miniFareRulesHtml?.reshedule[0]?.description}</td>
                    <td>{miniFareRulesHtml?.reshedule[0]?.amount}</td>
                  </tr>
                  <tr>
                    <td>Cancellation Charges</td>
                    {/* <td>Adult</td> */}
                    <td>{miniFareRulesHtml?.cancellation[0]?.description}</td>
                    <td>{miniFareRulesHtml?.cancellation[0]?.amount}</td>
                  </tr>
                </tbody>
              )}
            </table>
          </AppSidebar>
        )}
        {isopenAmenitiesdialog && (
          <AppSidebar
            sidebarTitle="Amenities"
            animatedClass="slide-from-right-animation"
            onHideSidebar={() => setisopenAmenitiesdialog(false)}
            className="overflow-auto flight-details-sidebar"
          >
            <div className="">
              {amenitiesList.length > 0 ? (
                <>
                  <div className="selected-flight-details__trip-details">
                    <div className="d-flex gap-2 trip-content align-items-center">
                      <span className="sector-span">{`${
                        flight.flightlegs[0].origin_name
                      }(${flight.flightlegs[0].origin}) -> ${
                        flight.flightlegs[flight.flightlegs.length - 1]
                          .destination_name
                      }(${
                        flight.flightlegs[flight.flightlegs.length - 1]
                          .destination
                      })`}</span>
                      <span className="date-span">
                        {`${getNewDateDisplayFormat(
                          flight.flightlegs[0].depdate,
                          MOMENT_DATE_MONTH_YEAR_VIEW_FORMAT,
                        )}`}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex flex-column">
                    <p className="fw-600">Services Available:</p>
                    {amenitiesList.map((x, index) => (
                      <span key={index} className="fs-14">
                        {index + 1} {x}
                      </span>
                    ))}
                  </div>
                </>
              ) : (
                <div>Amenities not available</div>
              )}
            </div>
          </AppSidebar>
        )}
        {showFlightDetails && (
          <AppSidebar
            sidebarTitle={formattedMessage('flight_details')}
            animatedClass="slide-from-right-animation"
            onHideSidebar={() => setShowFlightDetails(false)}
            className="flight-details-sidebar"
          >
            <div className="flight-details_tabs">
              <div className="flight-details_tabs_container">
                <button
                  onClick={() => setSelectedTab(FLIGHT_INFO)}
                  className={`flightDetailsTab ${
                    selectedTab === FLIGHT_INFO ? 'selected-tab-btn' : 'tab-btn'
                  }`}
                >
                  {formattedMessage('flight_information')}
                </button>
                <button
                  onClick={() => setSelectedTab(FARE_BREAKUP)}
                  className={`fareSummaryTab ${
                    selectedTab === FARE_BREAKUP
                      ? 'selected-tab-btn'
                      : 'tab-btn'
                  }`}
                >
                  Fare Summary
                </button>
                <button
                  onClick={handleOpenFareRules}
                  className={`fareRulesTab ${
                    selectedTab === FARE_RULES ? 'selected-tab-btn' : 'tab-btn'
                  }`}
                >
                  Fare Rules
                </button>
                {userSelectedFare.isminifarerulesrequired === 'true' && (
                  <button
                    onClick={() => handleShowMiniFareRules(userSelectedFare)}
                    className={`fareRulesTab ${
                      selectedTab === MINIFARES ? 'selected-tab-btn' : 'tab-btn'
                    }`}
                  >
                    Mini Fare Rules
                  </button>
                )}
              </div>
            </div>

            {selectedTab === FLIGHT_INFO && (
              <>
                <div className="selected-flight-details__trip-details mt-sm-2 ">
                  {journeyType === 'OneWay' ? (
                    <div className="d-flex gap-2 trip-content align-items-sm-center align-items-start flex-sm-row flex-column">
                      <span className="sector-span arrDeptDetails">{`${
                        searchRequest.originLocation.split(',')[0]
                      }(${searchRequest.origin}) -> ${
                        searchRequest.destinationLocation.split(',')[0]
                      }(${searchRequest.destination})`}</span>
                      <span className="date-span">
                        {`${formattedMessage(
                          tripTypeDict[searchRequest.journeytype],
                        )}  ${formatDate(
                          getNewDate(searchRequest.onwarddate),
                          DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                        )}`}
                      </span>
                    </div>
                  ) : (
                    <div className="d-flex gap-2 trip-content align-items-center">
                      <span className="sector-span arrDeptDetails">{`${
                        isOnward ? 'Onward' : 'Return'
                      } | ${
                        isOnward
                          ? searchRequest.originLocation.split(',')[0]
                          : searchRequest.destinationLocation.split(',')[0]
                      }(${
                        isOnward
                          ? searchRequest.origin
                          : searchRequest.destination
                      }) -> ${
                        isOnward
                          ? searchRequest.destinationLocation.split(',')[0]
                          : searchRequest.originLocation.split(',')[0]
                      }(${
                        isOnward
                          ? searchRequest.destination
                          : searchRequest.origin
                      })`}</span>
                      <span className="date-span">
                        {` ${
                          isOnward
                            ? formatDate(
                                getNewDate(searchRequest.onwarddate),
                                DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                              )
                            : formatDate(
                                getNewDate(searchRequest.returndate),
                                DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                              )
                        }`}
                      </span>
                    </div>
                  )}
                </div>
                <div className="p-0 p-lg-3">
                  <SelectedFlightDetails
                    selectedFlight={flight}
                    selectedFare={userSelectedFare}
                    fareInclusions={fareInclusions}
                  />
                </div>
              </>
            )}
            {selectedTab === FARE_BREAKUP && (
              <div className="fare-breakup mt-3">
                <div className="fare-breakup_header">
                  <div className="fare-breakup_header_title">
                    <FormattedMessage id="fare_breakup_summary_caps" />
                  </div>
                  <div className="fare-breakup_header_value">
                    <FormattedMessage id="amount_caps" />
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">Base Fare</div>
                  <div className="fare-breakup_value baseFare fareSummaryBreakUp ">
                    {formatCurrency(userSelectedFare.totalbasefare)}
                  </div>
                </div>
                {(() => {
                  const { otTax, yqTax, yrTax } = getFareTaxBreakup(
                    userSelectedFare,
                    searchRequest,
                  );
                  return (
                    <>
                      <div className="fare-breakup_content">
                        <div className="fare-breakup_title">OT Tax</div>
                        <div className="fare-breakup_value otTax fareSummaryBreakUp">
                          {formatCurrency(otTax)}
                        </div>
                      </div>
                      <div className="fare-breakup_content">
                        <div className="fare-breakup_title">YQ Tax</div>
                        <div className="fare-breakup_value yqTax fareSummaryBreakUp">
                          {formatCurrency(yqTax)}
                        </div>
                      </div>
                      <div className="fare-breakup_content">
                        <div className="fare-breakup_title">YR Tax</div>
                        <div className="fare-breakup_value yrTax fareSummaryBreakUp">
                          {formatCurrency(yrTax)}
                        </div>
                      </div>
                    </>
                  );
                })()}
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">Handling charges</div>
                  <div className="fare-breakup_value handlingCharges fareSummaryBreakUp">
                    {formatCurrency(userSelectedFare.handlingcharges)}
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">
                    {' '}
                    {appConfig?.isIntlClient === 'true' ? 'VAT' : 'GST'}
                  </div>
                  <div className="fare-breakup_value gst fareSummaryBreakUp">
                    {formatCurrency(userSelectedFare.servicetax)}
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">Other Charges</div>
                  <div className="fare-breakup_value otherCharges fareSummaryBreakUp">
                    {formatCurrency(userSelectedFare.transactionfee)}
                  </div>
                </div>
                {showInvoiceFare && (
                  <>
                    <div className="fare-breakup_content">
                      <div className="fare-breakup_title">Discount</div>
                      <div className="fare-breakup_value fareSummaryBreakUp">
                        {formatCurrency(userSelectedFare.discount)}
                      </div>
                    </div>
                    <div className="fare-breakup_content">
                      <div className="fare-breakup_title">TDS</div>
                      <div className="fare-breakup_value fareSummaryBreakUp">
                        {formatCurrency(userSelectedFare.tds)}
                      </div>
                    </div>
                    <div className="fare-breakup_footer">
                      <div className="fare-breakup_title">Net Fare</div>
                      <div className="fare-breakup_value fareSummaryBreakUp">
                        {formatCurrency(userSelectedFare.totalnet)}
                      </div>
                    </div>
                  </>
                )}
                <div className="fare-breakup_footer">
                  <div className="fare-breakup_title">Total Fare</div>
                  <div className="fare-breakup_value userTotalFare">
                    {formatCurrency(userSelectedFare.totalfq)}
                  </div>
                </div>
              </div>
            )}
            {selectedTab === FARE_RULES && (
              <div className="pt-3 mt-3">
                {/* <div
                  dangerouslySetInnerHTML={{ __html: fareRulesHtml }}
                  style={{ overflow: 'auto' }}
                  className="fare-rules-tabel fareRulesTable"
                /> */}
                <FareRulesContent
                  html={fareRulesHtml}
                  className="fare-rules-content"
                  style={{ overflow: 'auto' }}
                />
              </div>
            )}
          </AppSidebar>
        )}
        {isMobileWidth() && showMobileFares && (
          <AppSidebar
            onHideSidebar={handleCloseMobileFare}
            sidebarTitle={
              <div className="d-flex justify-content-between p-2 align-items-center flex-1">
                <div className="fs-14 white-color fw-400 ">
                  <div>
                    {searchRequest.originLocation.split(',')[0]} to{' '}
                    {searchRequest.destinationLocation.split(',')[0]}
                  </div>
                  <div className="fs-10">
                    <span>{searchRequest.journeytype} | </span>
                    {formatDate(
                      getNewDate(searchRequest.onwarddate),
                      DATE_MONTH_YEAR_VIEW_FORMAT,
                    )}{' '}
                    {journeyType === 'RoundTrip' &&
                      `| ${formatDate(
                        getNewDate(searchRequest.returndate),
                        DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                      )}`}
                  </div>
                </div>
                <div className="d-flex  align-items-center">
                  <AppIconButton
                    className="white-color p-0"
                    variant="transparent"
                    onClick={() => setShowShareOptions((prev) => !prev)}
                  >
                    {showShareOptions ? <MdClose /> : <MdOutlineShare />}
                  </AppIconButton>
                  {showShareOptions && (
                    <div className="d-flex align-items-center justify-content-center">
                      <AppIconButton
                        className="white-color p-0"
                        variant="transparent"
                        onClick={onShareViaEmail}
                      >
                        <MdOutlineEmail className="white-color fs-4" />
                      </AppIconButton>
                      <AppIconButton
                        className="white-color p-0"
                        variant="transparent"
                        onClick={onShareViaWhatsapp}
                      >
                        <MdOutlineWhatsapp className="white-color fs-4" />
                      </AppIconButton>
                    </div>
                  )}
                </div>
              </div>
            }
          >
            <>
              {selectedTab === FLIGHT_INFO && (
                <div className="p-0 p-lg-3">
                  <SelectedFlightDetails
                    selectedFlight={flight}
                    selectedFare={userSelectedFare}
                  />
                </div>
              )}
              {isMoreFaresLoading && (
                <div className="d-flex justify-content-center align-items-center p-3">
                  <div className="dots-container d-flex align-items-center">
                    <div className="dot" />
                    <div className="dot" />
                    <div className="dot" />
                  </div>
                  <span className="ms-2 fs-12 grey-color">
                    Loading more fares...
                  </span>
                </div>
              )}
              <div className="fare-components-list">
                {flight.flightfare.map((fare) => {
                  return appConfig.isMoreFaresRequiredForEachFareType ? (
                    <OneWayFareComponent
                      key={fare.nextraflightkey}
                      fare={fare}
                      userSelectedFare={userSelectedFare}
                      setUserSelectedFare={setUserSelectedFare}
                      fareInclusions={fareInclusions}
                      searchRequest={searchRequest}
                      showInvoiceFare={showInvoiceFare}
                      handleFareRulesClick={handleFareRulesClick}
                      flight={flight}
                      handleShowMiniFareRules={handleShowMiniFareRules}
                      handleBook={handleBook}
                      handleSelectForEmail={handleSelectForEmail}
                      isFareSelectedForEmail={isFareSelectedForEmail}
                      setIsLoading={setIsLoading}
                      journeyType={journeyType}
                      domint={domint}
                      isAmPmFormat={isAmPmFormat}
                    />
                  ) : (
                    <FareComponent key={fare.nextraflightkey} fare={fare} />
                  );
                })}
              </div>
            </>
          </AppSidebar>
        )}
      </div>

      <div
        className="fare-components-list fareComponentList"
        id={`scrollableDiv-${flight.nextraflightkey}`}
        style={{
          padding: showFares ? '10px' : '0',
          margin: showFares ? '-5px 1px 10px 1px' : '0',
        }}
        onScroll={(e) => {
          fareListScrollPositionRef.current = e.currentTarget.scrollLeft;
        }}
      >
        {flight.flightfare.length > 2 && showFares && (
          <div className="scroll-left-btn d-flex justify-content-center align-items-center">
            <button className="p-0 scroll-btn" onClick={scrollLeft}>
              <MdKeyboardArrowLeft />
            </button>
          </div>
        )}
        {showFares &&
          flight.flightfare.map((fare) => {
            return appConfig.isMoreFaresRequiredForEachFareType ? (
              <OneWayFareComponent
                key={fare.nextraflightkey}
                fare={fare}
                userSelectedFare={userSelectedFare}
                setUserSelectedFare={setUserSelectedFare}
                fareInclusions={fareInclusions}
                searchRequest={searchRequest}
                showInvoiceFare={showInvoiceFare}
                handleFareRulesClick={handleFareRulesClick}
                flight={flight}
                handleShowMiniFareRules={handleShowMiniFareRules}
                handleBook={handleBook}
                handleSelectForEmail={handleSelectForEmail}
                isFareSelectedForEmail={isFareSelectedForEmail}
                setIsLoading={setIsLoading}
                journeyType={journeyType}
                domint={domint}
                isAmPmFormat={isAmPmFormat}
              />
            ) : (
              <FareComponent key={fare.nextraflightkey} fare={fare} />
            );
          })}
        {flight.flightfare.length > 2 && showFares && (
          <div className="scroll-right-btn d-flex justify-content-center align-items-center">
            <button className="p-0 scroll-btn" onClick={scrollRight}>
              <MdKeyboardArrowRight />
            </button>
          </div>
        )}
      </div>

      {index === 2 && (
        <div className="add-space-container mb-2">
          <img
            src={
              getValueFromAppConfig('adspaceimage') || '/images/addspace.png'
            }
            alt=""
          />
        </div>
      )}
      <ClassAvailabilitySidebar
        isOpen={showClassAvailModal && availClassList.length > 0}
        onClose={handleCloseClassAvailabilityModal}
        availClassList={availClassList}
        selectedClasses={selectedClasses}
        onClassSelect={(availClass, index, sector) =>
          handleClassSelect(
            availClass,
            index,
            sector?.tripNum,
            availClass.cabinClass,
            sector?.gwFlightKey,
          )
        }
        onFetchFare={handleFetchFare}
        isFareFetched={isFareFetched}
        repriceResponse={repriceResponse}
        journeyType={journeyType}
        onClassSelectForRoundtrip={handleClassSelectForRoundtrip}
        onNavigateToBookingPage={handleNavigateToBookingPage}
        isLoading={isLoading}
      />
    </>
  );
}

OneWayResultCard.defaultProps = {
  selectedFare: undefined,
  // clearClassSelection: false,
  onNavigateToBookingPage: () => {},
  onClassSelectForRoundtrip: () => {},
};

OneWayResultCard.propTypes = {
  selectedFare: PropTypes.object,
  flight: PropTypes.object.isRequired,
  onFareSelection: PropTypes.func.isRequired,
  journeyType: PropTypes.string.isRequired,
  isOnward: PropTypes.bool.isRequired,
  domint: PropTypes.string.isRequired,
  onSelectForEmail: PropTypes.func.isRequired,
  showInvoiceFare: PropTypes.bool.isRequired,
  flightsForEmail: PropTypes.array.isRequired,
  searchRequest: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isAmPmFormat: PropTypes.bool.isRequired,
  onNavigateToBookingPage: PropTypes.func,
  onClassSelectForRoundtrip: PropTypes.func,
  onShareViaEmail: PropTypes.func.isRequired,
  onShareViaWhatsapp: PropTypes.func.isRequired,
  // clearClassSelection: PropTypes.bool,
};

export default OneWayResultCard;
